import React, {useRef, useState} from 'react';
import {Row, Col, Button, FormGroup, Label} from 'reactstrap';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import {ShowNotification} from '../../helpers/general/generalHelpers';
import Select from 'react-select';

// Import your Custom Quill Editor
import CustomQuillEditor from '../../components/CustomQuillEditor/CustomQuillEditor';

// The original component had a lot of unused/complex state initialization which can be simplified.
// We are keeping the core logic as requested.
const SubQuestion = (props) => {
    const {
        idx,
        forceUpdate,
        subQuestion,
        subQuestions,
        setSubQuestions,
        inputSampleAnswer,
        inputMarking,
        keyid,
        subSubQuestionBlock,
    } = props;

    // --- Start of Quill Integration ---
    // Ref for the main editor in this component instance
    const quillRef = useRef(null);
    // Refs for the nested sub-sub-question editors. We use an object to hold multiple refs.
    const subQuillRefs = useRef({});
    // --- End of Quill Integration ---

    // This state is preserved from the original component
    let subsubObj = subQuestions;
    let key = Object.keys(subQuestions) || '';
    let subSubKey = subsubObj && subsubObj?.[key?.[0]] && subsubObj?.[key?.[0]]?.subsubQuestions && Object.keys(subsubObj?.[key?.[0]]?.subsubQuestions) || '';

    const subquestionNames = ['a', 'b', 'c', 'd', 'e'];
    let subSubQuestion = false;
    if (subQuestion['subsubquestions']) {
        subSubQuestion = subQuestion['subsubquestions'];
    }

    // The rest of the original logic is preserved without changes
    const addSubSubQuestion = (idx) => {
        let newSubQuestions = subQuestions;
        let temp = {
            1: {
                body: '',
                marks: 0,
                sampleAnswer: '',
                markingAttachment: '',
                answer: false,
            }
        }
        newSubQuestions[key[0]].subsubQuestions = temp;
        setSubQuestions(newSubQuestions)
        forceUpdate();
    };

    const removeSubQuestion = (idx) => {
        if (subQuestions.length > 0) {
            let newSubQuestions = subQuestions;
            newSubQuestions.splice(idx, 1);
            setSubQuestions(newSubQuestions);
            forceUpdate();
        } else {
            ShowNotification({type: 'warning', message: 'Add Subquestions first.'});
        }
    };
    const removeSubSubQuestion = (idx, subIdx) => {
        if (subQuestions.length > 0) {
            if (subQuestions[idx]) {
                if (subQuestions[idx].subQuestions[subIdx]) {
                    let newSubQuestions = subQuestions;
                    newSubQuestions[idx].subQuestions.splice(subIdx, 1);
                    setSubQuestions(newSubQuestions);
                    forceUpdate();
                }
            }
        } else {
            ShowNotification({type: 'warning', message: 'Add Sub-Subquestions first.'});
        }
    };

    const [selectedOption, setSelectedOption] = useState();
    const [SubQuestionOption, setSubQuestionOption] = useState([
        {value: 'a', label: 'a'}, {value: 'b', label: 'b'}, {value: 'c', label: 'c'},
        {value: 'd', label: 'd'}, {value: 'e', label: 'e'}, {value: 'f', label: 'f'},
        {value: 'g', label: 'g'}, {value: 'h', label: 'h'}, {value: 'i', label: 'i'},
        {value: 'j', label: 'j'},
    ]);

    const [selectedSubSubOption, setSelectedSubSubOption] = useState({
        label: subSubKey?.[0] || '',
        value: subSubKey?.[0] || ''
    });
    const [SubSubQuestionOption, setSubSubQuestionOption] = useState([
        {value: '1', label: '1'}, {value: '2', label: '2'}, {value: '3', label: '3'},
        {value: '4', label: '4'}, {value: '5', label: '5'}, {value: '6', label: '6'},
    ]);

    return (
        <div style={{backgroundColor: '#F5F8FC', padding: '5px'}} className="section-bottom">
            <Row className="mx-1">
                <Col md="4" className="align-self-center">
                    <span
                        className="my-2 text-info">{!subSubQuestionBlock ? `Subquestion ${selectedOption?.value || 'a'}` : `SubSubquestion ${selectedSubSubOption?.value || '1'}`}</span>
                </Col>

                <Col md="4" style={{zIndex: 1000}}>
                    <FormGroup>
                        <Select
                            value={!subSubQuestionBlock ? selectedOption : selectedSubSubOption}
                            isSearchable
                            name="subjectSpeciality"
                            placeholder="Enter key"
                            options={!subSubQuestionBlock ? SubQuestionOption : SubSubQuestionOption}
                            className='mt-1'
                            onChange={(value) => {
                                if (!subSubQuestionBlock) {
                                    setSelectedOption(value)
                                    const newObj = {[value.label]: subQuestions[key[0]]};
                                    setSubQuestions(newObj)
                                    forceUpdate();
                                } else {
                                    setSelectedSubSubOption(value)
                                    const newSubsubQuestions = {
                                        [value.label]: {
                                            body: subsubObj[key[0]].subsubQuestions[subSubKey?.[0]]?.body || '',
                                            marks: subsubObj[key[0]].subsubQuestions[subSubKey?.[0]]?.marks || '',
                                            sampleAnswer: '',
                                            markingAttachment: '',
                                            answer: true,
                                        }
                                    };
                                    subsubObj[key[0]].subsubQuestions = newSubsubQuestions;
                                    setSubQuestions(subsubObj)
                                    forceUpdate();
                                }
                                forceUpdate();
                            }}
                        />
                    </FormGroup>
                </Col>


                <Col md="4">
                    <AvForm className="my-2 text-info text-right">
                        <AvField
                            required
                            name={'sub-question-marks_' + idx}
                            value={!subSubQuestionBlock ? subQuestion?.marks : subQuestions[Object.keys(subQuestions)[0]].subsubQuestions[Object.keys(subQuestions[Object.keys(subQuestions)[0]].subsubQuestions)]?.marks}
                            placeholder="Add Mark(s)"
                            type="number"
                            className="form-control filter-field"
                            onChange={(ev) => {
                                if (!subSubQuestionBlock) {
                                    let newSubQuestions = subQuestions;
                                    newSubQuestions[key[0]].marks = +ev.target.value;
                                    setSubQuestions(newSubQuestions);
                                    forceUpdate();
                                } else {
                                    subsubObj[key[0]].subsubQuestions[subSubKey?.[0]].marks = +ev.target.value;
                                    setSubQuestions(subsubObj);
                                    forceUpdate();
                                }
                            }}
                            id={'sub-question-marks_' + idx}
                        />
                    </AvForm>
                </Col>
            </Row>
            <span className="custom-control custom-checkbox mt-1">
                {/* --- Editor Replacement 1: Main SubQuestion Editor --- */}
                <CustomQuillEditor
                    ref={quillRef}
                    initialHtml={subQuestion.body}
                    onTextChange={() => {
                        if (quillRef.current) {
                            const htmlContent = quillRef.current.root.innerHTML;
                            if (!subSubQuestionBlock) {
                                let newSubQuestions = subQuestions;
                                newSubQuestions[keyid].body = htmlContent;
                                setSubQuestions(newSubQuestions);
                                forceUpdate();
                            } else {
                                let key = Object.keys(subQuestions);
                                subsubObj[key[0]].subsubQuestions[subSubKey[0]].body = htmlContent;
                                setSubQuestions(subsubObj);
                                forceUpdate();
                            }
                        }
                    }}
                />
            </span>
            {!subSubQuestionBlock && (
                <Button type="button" color="link" className="btn btn-link waves-effect ml-4" onClick={() => {
                    addSubSubQuestion(idx);
                }}>
                    <i className="bx font-size-20 bxs-plus-square"></i>
                    <span style={{verticalAlign: 'top'}} className="font-size-15"> Add Sub-Subquestion </span>
                </Button>
            )}

            {subQuestion?.subQuestions?.length < 1 && (
                <React.Fragment>
                    <Button type="button" color="link" className="btn btn-link waves-effect" onClick={() => {
                        inputSampleAnswer(idx);
                    }}>
                        <i className={`bx font-size-20 ${subQuestion.sampleAnswer ? 'bx-check-circle' : 'bxs-conversation'}`}></i>
                        <span style={{verticalAlign: 'top'}} className="font-size-15"> Sample Answer </span>
                    </Button>
                    <Button type="button" color="link" className="btn btn-link waves-effect" onClick={() => {
                        inputMarking(idx);
                    }}>
                        <i className={`bx font-size-20 ${subQuestion?.markingAttachment ? 'bx-badge-check' : 'bxs-badge-check'}`}></i>
                        <span style={{verticalAlign: 'top'}} className="font-size-15"> Marking </span>
                    </Button>
                </React.Fragment>
            )}

            <Button type="button" color="link" className="btn btn-link waves-effect"
                    onClick={() => removeSubQuestion(idx)}>
                <i className="bx font-size-24 bxs-trash text-danger"></i>
            </Button>
            {subSubQuestion &&
                Object.keys(subSubQuestion)?.map((key, subIdx) => {
                    return (
                        <div key={subSubQuestion[key].id || key} style={{backgroundColor: '#FEF6FA'}}
                             className="section-bottom">
                            <Row className="mx-1">
                                <Col md="6" className="align-self-center">
                                    <span
                                        className="my-2 text-pink">{`Sub-Subquestion (${subquestionNames[idx]})(${subIdx + 1})`}</span>
                                </Col>
                                <Col md="6">
                                    <AvForm className="my-2 text-info text-right">
                                        <AvField
                                            required
                                            name={'sub-question-marks_' + subIdx}
                                            value={subSubQuestion[key].marks}
                                            placeholder="Add Mark(s)"
                                            type="number"
                                            className="form-control filter-field"
                                            onChange={(ev) => {
                                                let newSubQuestions = subQuestions;
                                                newSubQuestions[keyid].subsubquestions[key].marks = +ev.target.value;
                                                setSubQuestions(newSubQuestions);
                                                forceUpdate();
                                            }}
                                            id={'sub-question-marks_' + subIdx}
                                        />
                                    </AvForm>
                                </Col>
                            </Row>
                            <span className="custom-control custom-checkbox mt-1">
                               {/* --- Editor Replacement 2: Nested Sub-SubQuestion Editor --- */}
                                <CustomQuillEditor
                                    // Assign a dynamic ref from our refs object
                                    ref={(el) => (subQuillRefs.current[key] = el)}
                                    initialHtml={subSubQuestion[key].body}
                                    onTextChange={() => {
                                        const editorInstance = subQuillRefs.current[key];
                                        if (editorInstance) {
                                            const htmlContent = editorInstance.root.innerHTML;
                                            let newSubQuestions = subQuestions;
                                            newSubQuestions[keyid]['subsubquestions'][key].body = htmlContent;
                                            setSubQuestions(newSubQuestions);
                                            forceUpdate();
                                        }
                                    }}
                                />
                            </span>
                            <Button type="button" color="link" className="btn btn-link waves-effect m3-5"
                                    onClick={() => {
                                        inputSampleAnswer(idx, subIdx);
                                    }}>
                                <i className={`bx font-size-20 ${subSubQuestion[key].sampleAnswer ? 'bx-check-circle' : 'bxs-conversation'}`}></i>
                                <span style={{verticalAlign: 'top'}} className="font-size-15"> Sample Answer </span>
                            </Button>
                            <Button type="button" color="link" className="btn btn-link waves-effect" onClick={() => {
                                inputMarking(idx, subIdx);
                            }}>
                                <i className={`bx font-size-20 ${subSubQuestion[key]?.markingAttachment ? 'bx-badge-check' : 'bxs-badge-check'}`}></i>
                                <span style={{verticalAlign: 'top'}} className="font-size-15"> Marking </span>
                            </Button>
                            <Button type="button" color="link" className="btn btn-link waves-effect"
                                    onClick={() => removeSubSubQuestion(idx, subIdx)}>
                                <i className="bx font-size-24 bxs-trash text-danger"></i>
                            </Button>
                        </div>
                    );
                })}
        </div>
    );
};
export default SubQuestion;